export const AUTH_USER = 'AUTH_USER';

export const FETCH_USER = 'FETCH_USER';

export const FETCH_USER_MACHINES = 'FETCH_USER_MACHINES';

export const FETCH_ENDPOINT_ACCESS = 'FETCH_ENDPOINT_ACCESS';

export const FETCH_USER_INVOICES = 'FETCH_USER_INVOICES';

export const FETCH_USER_BACKUPS = 'FETCH_USER_BACKUPS';

export const FETCH_SALES_OPENING_START_TIME = 'FETCH_BUSINESS_OPENING_START_TIME';

export const FETCH_Z_REPORTS = 'FETCH_Z_REPORTS';

export const FETCH_STANDARD_REPORTS = 'FETCH_STANDARD_REPORTS';

export const FETCH_COMPARISON_REPORTS = 'FETCH_COMPARISON_REPORTS';

export const FETCH_DASHBOARD_REPORTS = 'FETCH_DASHBOARD_REPORTS';

export const FETCH_TRANSACTION_REPORTS = 'FETCH_TRANSACTIONS';

export const FETCH_TRANSACTION_REPORTS_TOTAL = 'FETCH_TRANSACTIONS_TOTAL';

export const FETCH_TRANSACTION_REPORTS_OFFSET = 'FETCH_TRANSACTIONS_OFFSET';

export const FETCH_DASHBOARD_PRODUCTS = 'FETCH_DASHBOARD_PRODUCTS';

export const FETCH_DASHBOARD_CATEGORIES = 'FETCH_DASHBOARD_CATEGORIES';

export const FETCH_ADMINISTRATION_DATA = 'FETCH_ADMINISTRATION_DATA';

export const FETCH_ADMINISTRATION_EXTRA_DATA = 'FETCH_ADMINISTRATION_EXTRA_DATA';

export const FETCH_ADMINISTRATION_LIST_DATA = 'FETCH_ADMINISTRATION_LIST_DATA';

export const FETCH_ADMINISTRATION_BOOKKEEPING = 'FETCH_ADMINISTRATION_BOOKKEEPING';

export const FETCH_VAT_OPTIONS = 'FETCH_VAT_OPTIONS';

export const FETCH_ADMINISTRATION_DICTIONARIES = 'FETCH_ADMINISTRATION_DICTIONARIES';

export const CREATE_FRESHDESK_TICKET = 'CREATE_FRESHDESK_TICKET';

export const FETCH_FRESHDESK_TICKETS = 'FETCH_FRESHDESK_TICKETS';

export const UPDATE_FRESHDESK_TICKET = 'UPDATE_FRESHDESK_TICKET';

export const FETCH_FRESHDESK_CONVERSATIONS = 'FETCH_FRESHDESK_CONVERSATIONS';

export const UPDATE_FRESHDESK_CONVERSATIONS = 'UPDATE_FRESHDESK_CONVERSATIONS';

export const FETCH_FRESHDESK_USER_ID = 'FETCH_FRESHDESK_USER_ID';

export const REQUEST_RESULT = 'REQUEST_RESULT';